// extracted by mini-css-extract-plugin
module.exports = {"SendResultsForm_Loader":"styles_SendResultsForm_Loader__Z4RRJ","SendResultsForm_Button":"styles_SendResultsForm_Button__C8YDt"};